export const CHAT_INPUT_MAX_LENGTH = 2000
export const CHAT_FORM_MAX_LENGTH = 500
export const CHAT_INPUT_MIN_ROWS = 1
export const CHAT_INPUT_MAX_ROWS = 6
export const AUTH_FORM_BASE_HEIGHT = 105
export const AUTH_FORM_ONE_INPUT_HEIGHT = 60
export const AUTH_FORM_DEFAULT_MAX_LENGTH = 255
export const AUTH_FORM_PHONE_MAX_LENGTH = 32
